import {z} from '@hono/zod-openapi';

export const importNissanPriceListResultSchema = z.object({
  totalDataRows: z.number().int().nonnegative(),
  importedCount: z.number().int().nonnegative(),
  skippedCount: z.number().int().nonnegative(),
  deactivatedCount: z.number().int().nonnegative(),
});

export type ImportNissanPriceListResult = z.infer<typeof importNissanPriceListResultSchema>;
